import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('hero-slider-full', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';
    this.sliderId = '#hero-slider--' + this.id;
    this.thisSlider = document.querySelector('#hero-slider--' + this.id);

    // Reduce slide count by one to align with the 0 positioned slide
    const slidesCount = Number(this.container.dataset.slides - 1);

    // Parse the settings string passed through from liquid
    this.userSettings = JSON.parse(this.settings);

    if (this.thisSlider) {
      var slider = new Flickity(this.thisSlider, {
        freeScroll: false,
        autoplay: this.userSettings.autoplay,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });

      const previousButton = this.container.querySelector(
        '.btn--control__prev'
      );
      previousButton.addEventListener('click', function() {
        slider.previous();
      });
      const nextButton = this.container.querySelector('.btn--control__next');
      nextButton.addEventListener('click', function() {
        slider.next();
      });

      slider.on('change', function() {
        if (slider.selectedIndex === 0) {
          previousButton.setAttribute('disabled', 'disabled');
          nextButton.removeAttribute('disabled');
        } else if (slider.selectedIndex === slidesCount) {
          nextButton.setAttribute('disabled', 'disabled');
          previousButton.removeAttribute('disabled');
        } else {
          nextButton.removeAttribute('disabled');
          previousButton.removeAttribute('disabled');
        }
      });
    }
  },
});
